// extracted by mini-css-extract-plugin
export var container = "_m2-0";
export var segment = "_m2-2";
export var segmentActive = "_m2-3";
export var track = "_m2-1";